import i18next from 'i18next';

import type { SupportedInterviewLanguage } from '@kiku/config/constants';
import en from './locales/en/common.json' with { type: 'json' };
import es from './locales/es/common.json' with { type: 'json' };

// Re-export to activate i18next module augmentation for consumers
export type { Resources, SupportedLocale } from './i18n.types.js';
export type { SupportedInterviewLanguage } from '@kiku/config/constants';

const i18n = i18next.createInstance();

void i18n.init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: { common: en },
    es: { common: es }
  },
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  initImmediate: false
});

export function createServerTranslator(
  locale: SupportedInterviewLanguage
): ReturnType<typeof i18n.getFixedT> {
  return i18n.getFixedT(locale);
}
